import { cn } from "@omni/utils/styles";

import { useDeliveryItemContext } from "@/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/context/deliveryItem.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const MinimumOrderQuantity = ({ className }: Props) => {
    const { t } = useGranite();

    const { minimumOrderQuantity, roundingValue } = useDeliveryItemContext();

    if (minimumOrderQuantity <= 1) return null;

    return (
        <p className={cn("tw:text-sm tw:font-light tw:m-0", className)}>
            {roundingValue > 1 &&
                t("general.ecommerce.roundingValue", roundingValue)}
            {roundingValue <= 1 &&
                t(
                    "general.ecommerce.minimumOrderQuantity",
                    minimumOrderQuantity
                )}
        </p>
    );
};
